import getAllJoinRequests from "./getAllJoinRequests";
import responseMembersRequests from "./responseMembersRequests";

const joinRequests = {
  getAllJoinRequests,
  responseMembersRequests,
};

export default joinRequests;
